import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '@/store/index'
import { isTokenExpired, getRolesFromToken } from '@/services/JwtDecoder'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginAndRegister/Login.vue'),
      meta: { layout: 'full', requiresGuest: true },
    },

    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: { layout: 'full' },
    },

    {
      path: '/setting/user/search',
      name: 'usersearch',
      component: () => import('@/views/Setting/UserSearch.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'usersearch',
        // layout: 'full',
      },
    },
    {
      path: '/setting/user/form',
      name: 'userform',
      component: () => import('@/views/Setting/UserForm.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'userform',
        // layout: 'full',
      },
    },
    {
      path: '/request/search',
      name: 'requestsearch',
      component: () => import('@/views/JobRequest/JobRequestSearch.vue'),
      props: true,
      meta: {
        requiresAuth: true,
        pageTitle: 'requestsearch',
        // layout: 'full',
      },
    },

    {
      path: '/update/search',
      name: 'updatesearch',
      component: () => import('@/views/JobList/UpdateSearch.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['WORKER'],
        pageTitle: 'updatesearch',
        // layout: 'full',
      },
    },

    {
      path: '/admin/form',
      name: 'adminform',
      component: () => import('@/views/AdminReviwer/AdminForm.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'AdminForm',
        // layout: 'full',
      },
    },
    {
      path: '/admin/search',
      name: 'adminsearch',
      component: () => import('@/views/AdminReviwer/AdminSearch.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'adminsearch',
        // layout: 'full',
      },
    },

    {
      path: '/mst/department/form',
      name: 'departmentform',
      component: () => import('@/views/MasterData/DepartmentForm.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'departmentform',
        // layout: 'full',
      },
    },

    // หน้าข้อมูล

    {
      path: '/cate',
      name: 'CategoryManagement',
      component: () => import('@/views/MasterData/EditCategory.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'CategoryManagement',
        // layout: 'full',
        props: true,
      },
    },
    {
      path: '/expense',
      name: 'Expense',
      component: () => import('@/views/MasterData/EditExpenseCate.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'Expense',
        // layout: 'full',
        // props: true // Pass route params as props
      },
    },
    {
      path: '/device',
      name: 'device',
      component: () => import('@/views/MasterData/EditDeviceCate.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'deviceCate',
        // layout: 'full',
        // props: true // Pass route params as props
      },
    },
    // สถานที่
    {
      path: '/location',
      name: 'location',
      component: () => import('@/views/MasterData/EditLocation.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'location',
        // layout: 'full',
        // props: true // Pass route params as props
      },
    },
    {
      path: '/devicelist',
      name: 'devicelist',
      component: () => import('@/views/MasterData/DeviceList.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'devicelist',
        // layout: 'full',
        // props: true // Pass route params as props
      },
    },
    {
      path: '/jobtitle',
      name: 'jobtitle',
      component: () => import('@/views/MasterData/EditJobtitle.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'jobtitle',
        // layout: 'full',
        // props: true // Pass route params as props
      },
    },
    // หน้าตั้งค่า
    {
      path: '/setting/user/form/register',
      name: 'registersetting',
      component: () => import('@/views/Setting/Regsiter_Setting.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'Register',
        // layout: 'full',
      },
    },

    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/views/Calendar/calendarTable.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN', 'WORKER'],
        pageTitle: 'calendar',
        // layout: 'full',
      },
    },

    {
      path: '/calendarView',
      name: 'calendarView',
      component: () => import('@/views/Calendar/calendarTableView.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'calendarView',
        // layout: 'full',
      },
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/AdminReviwer/Dashboard.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['SYSTEM', 'ADMIN'],
        pageTitle: 'dashboard',
        // layout: 'full',
      },
    },
	
	{
      path: '/resetpassword',
      name: 'resetpassword',
      component: () => import('@/views/LoginAndRegister/Editpass_sign.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'resetpassword',
        // layout: 'full',
      },
    },

    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('accessToken')
  const isExpired = token ? isTokenExpired(token) : true
  const roles = !isExpired ? getRolesFromToken(token) : []

  const hasRole = requiredRoles => requiredRoles.some(role => roles.includes(role))

  // ตรวจสอบสถานะการล็อกอิน
  if (isExpired) {
    if (to.meta.requiresGuest) {
      return next()
    }
    if (to.name !== 'login') {
      localStorage.removeItem('accessToken')
      return next({ name: 'login' })
    }
  } else {
    if (to.matched.some(record => record.meta.requiresRoles)) {
      if (!hasRole(to.meta.requiresRoles)) {
        const roleStartPages = {
          SYSTEM: 'adminsearch',
          ADMIN: 'adminsearch',
          REVIEWER: 'adminsearch',
          APPROVER: 'requestsearch',
          USER: 'requestsearch',
          WORKER: 'updatesearch',
        }
        const redirectPath = Object.keys(roleStartPages).find(role => roles.includes(role))
        if (to.name !== roleStartPages[redirectPath]) {
          return next({ name: roleStartPages[redirectPath] })
        }
      }
    }

    if (to.matched.some(record => record.meta.requiresAuth) && !token) {
      if (to.name !== 'login') {
        return next({ name: 'login' })
      }
    }
  }

  next()
})

// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
